// AssignABTest will assign a given customer session to one of it's group.
export const ABTestService_AssignABTestsLazy = () =>
  import("./service.grpc").then((m) => m.ABTestService_AssignABTests);
ABTestService_AssignABTestsLazy.method =
  "aysa_api.services.ab_tests.ABTestService/AssignABTests" as const;

// TrackABTest tracks AB test related events for analytics purposes.
export const ABTestService_TrackABTestLazy = () =>
  import("./service.grpc").then((m) => m.ABTestService_TrackABTest);
ABTestService_TrackABTestLazy.method =
  "aysa_api.services.ab_tests.ABTestService/TrackABTest" as const;
